import React from 'react';

const NavOrganization = (props: any) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M13.4729 18.4441C14.2864 19.2575 14.2864 20.5764 13.4729 21.3899C12.6594 22.2034 11.3406 22.2034 10.5271 21.3899C9.71363 20.5764 9.71363 19.2576 10.5271 18.4441C11.3406 17.6306 12.6594 17.6306 13.4729 18.4441"
      stroke="stroke"
      strokeWidth="1.5"
    />
    <path
      d="M13.4729 18.4441C14.2864 19.2575 14.2864 20.5764 13.4729 21.3899C12.6594 22.2034 11.3406 22.2034 10.5271 21.3899C9.71363 20.5764 9.71363 19.2576 10.5271 18.4441C11.3406 17.6306 12.6594 17.6306 13.4729 18.4441"
      stroke="stroke"
      strokeWidth="1.5"
    />
    <path
      d="M13.4729 2.6101C14.2864 3.42356 14.2864 4.74244 13.4729 5.55591C12.6594 6.36937 11.3406 6.36937 10.5271 5.55591C9.71363 4.74244 9.71363 3.42357 10.5271 2.6101C11.3406 1.79663 12.6594 1.79663 13.4729 2.6101"
      stroke="stroke"
      strokeWidth="1.5"
    />
    <path
      d="M5.55591 10.5271C6.36937 11.3406 6.36937 12.6594 5.55591 13.4729C4.74244 14.2864 3.42357 14.2864 2.6101 13.4729C1.79663 12.6594 1.79663 11.3406 2.6101 10.5271C3.42356 9.71363 4.74244 9.71363 5.55591 10.5271"
      stroke="stroke"
      strokeWidth="1.5"
    />
    <path
      d="M21.3899 10.5271C22.2034 11.3406 22.2034 12.6594 21.3899 13.4729C20.5764 14.2864 19.2576 14.2864 18.4441 13.4729C17.6306 12.6594 17.6306 11.3406 18.4441 10.5271C19.2575 9.71363 20.5764 9.71363 21.3899 10.5271"
      stroke="stroke"
      strokeWidth="1.5"
    />
    <path
      d="M18.4009 7.59912C17.8619 6.81612 17.1839 6.13812 16.4009 5.59912"
      stroke="stroke"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.59912 16.4009C6.13812 17.1839 6.81612 17.8619 7.59912 18.4009"
      stroke="stroke"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.59912 5.59912C6.81612 6.13812 6.13812 6.81612 5.59912 7.59912"
      stroke="stroke"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.4009 18.4009C17.1839 17.8619 17.8619 17.1839 18.4009 16.4009"
      stroke="stroke"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default NavOrganization;
